import React from 'react';
import { mountTable, unmountTable } from '../Components/JQueryTable/JQueryTableLogic.jsx';
import JQueryTableComponent from '../Components/JQueryTable/JQueryTableComponent.jsx';
import { API_ROOT } from '../../variables/api-config';
import Button from '../../elements/CustomButton/CustomButton.jsx';

const dataTable = {
  headerRow: ["Número", "Inicio", "Fin", "Estado", "Acciones"],
  footerRow: ["Número", "Inicio", "Fin", "Estado", "Acciones"]
};

class Convocatoria extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      someState: null,
    };
    this.editFromTable = this.editFromTable.bind(this);
    this.addTeams = this.addTeams.bind(this);
    this.customAction = [
      {
        htmlString: '<a class="btn btn-simple btn-success btn-icon edit"><i class="fa fa-plus text-right"></i></a>',
        actionString: 'click',
        actionFunction: this.addTeams,
      },
    ];
  }
  editFromTable(data){
    this.props.openCreateModal(parseInt(data[0], 10));
  }
  addTeams(data){
    this.props.openUpdateModal(parseInt(data[0], 10));
  }
  componentDidMount() {
    mountTable(API_ROOT + "/incubation/announcements", "convocatoria", this.editFromTable, null, this.customAction);
  }
  componentWillUnmount() {
    unmountTable('convocatoria');
  }
  shouldComponentUpdate() {
    return true;
  }
  render() {
    return(
      <div className="fresh-datatables">
        <div style={{ paddingBottom: 5 }} className="visible-xs-block">
          <Button bsStyle="primary" fill wd block bsSize="small" onClick={() => this.props.openCreateModal(0)}>
            Nueva convocatoria
          </Button>
        </div>
        <div style={{ textAlign: "right", paddingBottom: 5 }} className="hidden-xs">
          <Button bsStyle="primary" fill wd bsSize="small" onClick={() => this.props.openCreateModal(0)}>
            Nueva convocatoria
          </Button>
        </div>
        <JQueryTableComponent dataTable={dataTable} identifier="convocatoria" />
      </div>
    );
  }
}

export default Convocatoria;



// WEBPACK FOOTER //
// ./src/views/Incubation/Convocatoria.jsx